import { showErrorMessage, showSuccessMessage } from '../../common/Toaster';
import {
	SET_AUTH_FAILED_MSG,
	SET_AUTH_REFRESH_TOKEN,
	SET_AUTH_TOKENS,
	SIGNOUT_AUTH_SUCCESS,
	UPDATE_AUTH_USER,
} from '../../constants/ActionTypes';
import jwtAxios from '../../services/axiosInstance/ApiConfig';
import { setAuthToken } from '../../utils';

type loginPayload = {
	email: string;
	password: string;
}

type signUpPayload = {
	name: string
} & loginPayload

type setTokenPayload = {
	token: string;
	refreshToken: string;
}

export const getHeaders = () => {
	return {
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	}
}

export const onJwtSignIn = ({ email, password }: loginPayload) => {
	return async (dispatch: any) => {
		let body = { email, password };
		try {
			const resp = await jwtAxios.post('users/signin', body)
			if (resp && resp.status === 200) {
				setAuthToken(resp.data.token, resp.data.refresh)
				localStorage.setItem("auth_user", JSON.stringify(resp.data))
				dispatch(updateAuthUser(resp.data));
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message, 'top-center')
		}
	};
};

export const onUpdateUser = (payload: any) => {
	return async (dispatch: any) => {
		try {
			const resp = await jwtAxios.put('/users/update-seller', payload, {
				headers: getHeaders()
			})
			if (resp && resp.status === 200) {
				showSuccessMessage('User updated successfully!')
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message)
		}
	}
}

export const onJwtSignUp = ({ name, email, password }: signUpPayload) => {
	return async (dispatch: any) => {
		let body = { name, email, password };
		try {
			const resp = await jwtAxios.post('users/signup', body)
			if (resp && resp.status === 200) {
				showSuccessMessage('You have registered successfully!')
				setAuthToken(resp.data.token, resp.data.refresh)
				localStorage.setItem("auth_user", JSON.stringify(resp.data))
				dispatch(updateAuthUser(resp.data));
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message)
		}
	};
};

export const onSignInWithOTP = (phone: string) => {
	return async (dispatch: any) => {
		let body = { phone };
		try {
			const resp = await jwtAxios.post('users/signinThroughOTP', body)
			if (resp && resp.status === 200) {
				setAuthToken(resp.data.token, resp.data.refresh)
				localStorage.setItem("auth_user", JSON.stringify(resp.data))
				dispatch(updateAuthUser(resp.data));
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message)
		}
	};
};

export const onForgotPassword = (email: string) => {
	return async (dispatch: any) => {
		try {
			const resp = await jwtAxios.post('auth/forgotpassword', { email })
			if (resp && resp.status === 200) {
				showSuccessMessage(resp.data.msg);
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message)
		}
	};
};

export const loadJWTUser = (id: string, isSeller: boolean) => {
	return async (dispatch: any) => {
		try {
			const res: any = await jwtAxios.get('users/authUser/' + id + '/' + isSeller, {
				headers: getHeaders()
			});
			dispatch({
				type: UPDATE_AUTH_USER,
				payload: {
					profile: res.data.profilePic,
					...res.data
				},
			});
		} catch (err: any) {
			showErrorMessage(err.response.data.detail)
		}
	};
};

export const setJWTToken = (data: setTokenPayload) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_AUTH_TOKENS,
			payload: data,
		});
	};
};

export const setAuthFailedMsg = (error: string | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_AUTH_FAILED_MSG,
			payload: error,
		});
	};
};

export const setJWTRefreshToken = (refresh: string) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_AUTH_REFRESH_TOKEN,
			payload: refresh,
		});
	};
};

export const updateAuthUser = (user: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: UPDATE_AUTH_USER,
			payload: user,
		});
	};
};

export const onJWTAuthSignout = () => {
	return (dispatch: any) => {
		dispatch({ type: SIGNOUT_AUTH_SUCCESS });
		setAuthToken('', '')
	};
};
